module.exports = __webpack_public_path__ + "static/media/carousel02.d4a7f150.jpg";